import { createSlice } from "@reduxjs/toolkit";

const storedAuth = JSON.parse(window.localStorage.getItem("PU"));
const defaultvalue = {
  Token: null,
  Branch: [],
  CustID: null,
  BranchID: null,
  CustPortalID: null,
  IsAdmin: false,
  Name: null,
  Status: null,
  EmailID: null,
  SBranch: null,
  isUserLogin: false,
  ShippingAddress: [],
  BillingAddress: [],
  UserName: '',
  IsPartner: false,
  IsCarriage: false,
  Address: null,
  ContactPerson: null,
  IsShowCart: false,
  Logo: "",
  CustomerEmailID: "",
  CustomerName: ""


};
const initialState = storedAuth || defaultvalue;

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, { payload }) => {
      Object.assign(state, payload);
      state.isUserLogin = !!payload.Status;

      window.localStorage.setItem("PU", JSON.stringify({ ...state }));
    },
    clearCredentials: () => {
      window.localStorage.removeItem("PU");
      return defaultvalue;
    }

  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;

export default authSlice.reducer;
